/* src/app/home-new/home-summary-section/print-group-folder-item/print-group-folder-item.component.scss */
.container-folder {
  padding: 8px;
  border-radius: 22px;
  border: 1px solid #cbcbcb;
  background-color: #f6f6f6;
  width: fit-content;
}
.container-folder.selected {
  background-color: #d4ecff;
  border-color: #43c0f6;
}
.container-folder.out-of-stock {
  border-color: #eb445a;
}
.edit-folder-message {
  padding: 5px;
  border-radius: 20px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  -webkit-backdrop-filter: blur(2.5px);
  backdrop-filter: blur(2.5px);
  color: #259dff;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.group-folder {
  width: 275px;
  position: relative;
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
}
.group-folder.selected {
  filter: drop-shadow(0px -4px 10px rgba(0, 0, 0, 0.2));
}
.group-folder .folder-shape-div {
  background-image: url("./media/top-folder-X23S37WK.svg");
  background-repeat: no-repeat;
  background-size: cover;
  width: 275px;
  height: 44px;
}
.group-folder .folder-icon {
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  margin-right: 5px;
}
.group-folder .group-name {
  position: absolute;
  top: 9px;
  left: 10px;
  right: 44%;
  background: white;
  max-height: 32px;
  z-index: 9;
  cursor: default;
}
.group-folder .group-name .group-name_abbreviated {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.group-folder .group-name:hover .group-name_full {
  opacity: 1;
}
.group-folder .group-folder_content {
  padding: 10px;
  background-color: white;
  border-radius: 0px 0px 20px 20px;
  height: 200px;
}
.group-folder .group-folder_content .fileCount {
  color: #949494;
  z-index: 10;
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.group-folder .group-folder_content .fileCount .price {
  font-size: 20px;
  font-family: "League Spartan";
}
.group-folder .group-folder_content .qtyCounter {
  flex: 1 0;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  max-height: 55px;
}
.group-folder .group-folder_content .qtyCounter .label {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 16px;
}
.group-folder .group-folder_content .qtyCounter .number {
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: #259dff;
}
.popover-button {
  width: 38px;
  height: 38px;
  aspect-ratio: 1/1;
  border-radius: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  fill: rgba(255, 255, 255, 0.1);
  margin: 0;
  min-height: 0;
}
.popover-button::part(native) {
  padding: 0;
}
@media (max-width: 1024px) {
  .popover-button {
    top: 25px;
  }
}
ion-popover {
  --width: auto;
}
ion-popover::part(content) {
  border-radius: 15px;
}
ion-popover.out-of-stock-popover {
  --background: #ffe6e9;
  color: #eb445a;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
}
ion-popover.out-of-stock-popover li {
  font-weight: 600;
}
.out-of-stock-icon {
  border: 1px solid #eb445a;
  border-radius: 10px;
  background-color: #ffe6e9;
  box-shadow: 0 2px 4px 0 rgba(235, 68, 90, 0.4);
  padding: 7px;
  color: #eb445a;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
@media (max-width: 1104px) {
  .group-folder {
    max-width: 360px !important;
    margin: auto !important;
  }
}
/*# sourceMappingURL=print-group-folder-item.component-M6QTM25E.css.map */
